export default __webpack_public_path__ + "static/media/famine.1c2bab59.svg";